// CART TOGGLE
function toggleCart() {
  document.getElementById('cartSidebar').classList.toggle('open');
  document.getElementById('cartOverlay').classList.toggle('open');
}

// ADD TO CART
function addToCart(variantId, btn) {
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(item => {
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
    updateCartDrawer();
    toggleCart();
    showToast('🛒 Added to cart!');
  })
  .catch(() => {
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
    showToast('❌ Something went wrong. Try again.');
  });
}

// UPDATE CART QUANTITY
function updateCart(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(() => updateCartDrawer());
}

// UPDATE CART DRAWER
function updateCartDrawer() {
  fetch('/cart.js')
  .then(r => r.json())
  .then(cart => {
    // Update badge
    const badge = document.getElementById('cartBadge');
    const count = document.getElementById('cartCount');
    if (badge) badge.textContent = cart.item_count;
    if (count) count.textContent = cart.item_count;

    const itemsEl = document.getElementById('cartItems');
    if (!itemsEl) return;

    // Always ensure footer exists in the DOM
    let footer = document.querySelector('.cart-footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-footer';
      document.getElementById('cartSidebar').appendChild(footer);
    }

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="empty-cart"><div class="empty-cart-icon">🛒</div><p>Your cart is empty.<br>Start shopping!</p></div>';
      footer.style.display = 'none';
      return;
    }

    let html = '';
    cart.items.forEach(item => {
      html += `
        <div class="cart-item">
          <div class="cart-item-img">
            ${item.image ? `<img src="${item.image}" alt="${item.title}">` : '🛍️'}
          </div>
          <div class="cart-item-info">
            <div class="cart-item-name">${item.title}</div>
            <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            <div class="cart-item-qty">
              <button class="qty-btn" onclick="updateCart('${item.key}', ${item.quantity - 1})">−</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" onclick="updateCart('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <button class="cart-remove" onclick="updateCart('${item.key}', 0)">Remove</button>
          </div>
        </div>`;
    });
    itemsEl.innerHTML = html;

    const gst = Math.round(cart.total_price / 11);
    const subtotalEx = cart.total_price - gst;

    footer.style.display = '';
    footer.innerHTML = `
      <div class="cart-subtotal"><span>Subtotal (ex GST)</span><span>${formatMoney(subtotalEx)}</span></div>
      <div class="cart-gst"><span>GST (10%)</span><span>${formatMoney(gst)}</span></div>
      <div class="cart-total"><span>Total (inc GST)</span><span>${formatMoney(cart.total_price)}</span></div>
      <a href="/checkout" class="checkout-btn">Proceed to Checkout →</a>`;
  });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// TOAST
let toastTimer;
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 3000);
}

// COUNTDOWN
function updateCountdown() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(23, 59, 59, 999);
  const diff = midnight - now;
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const hoursEl = document.getElementById('hours');
  const minsEl = document.getElementById('mins');
  const secsEl = document.getElementById('secs');
  if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
  if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
  if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
}
setInterval(updateCountdown, 1000);
updateCountdown();

// NEWSLETTER
function subscribeNewsletter() {
  const email = document.getElementById('newsletterEmail');
  if (email && email.value) {
    showToast('🎉 Subscribed! Welcome to OZ Online Depot.');
    email.value = '';
  } else {
    showToast('Please enter your email address.');
  }
}
